export default __webpack_public_path__ + "static/squares-bg-image-7565ad151332bc10bda68001cf62b411.png";